import axios from 'axios';


/**
 * Axios instance specifically for file downloads using pre-signed URLs.
 *
 * Reason for creating this instance:
 * - Pre-signed URLs are already authenticated and should not include additional headers like `Authorization`.
 * - Using the global Axios instance could result in unintended issues (e.g., conflicting authentication types).
 * - This instance ensures file download requests from Minio are isolated and free from global interceptor logic.
 *
 * Usage:
 * - Import `axiosFileDownload` and use it to make requests to pre-signed URLs.
 */
export const axiosFileDownload = axios.create();
